import { Text, TextProps } from 'grommet'

import { formatDate } from 'util/date'

const DisplayDate = ({ date, ...props }: { date: string | number | Date } & TextProps) => (
  <Text {...props}>{formatDate(date)}</Text>
)
export default DisplayDate
